(() => {
 if (window.gppCardHoverInitialized) return;
 window.gppCardHoverInitialized = true;
 const attach = root => root.querySelectorAll('.gpp-card-hover__secondary').forEach(img => {
  if (img.dataset.gppHoverBound) return;
  img.dataset.gppHoverBound = 'true';
  const update = () => img.parentElement?.classList.toggle('gpp-card-hover--ready', img.complete && img.naturalWidth > 0);
  img.addEventListener('load', update); img.addEventListener('error', update); update();
 });
 attach(document);
 new MutationObserver(records => records.forEach(r => r.addedNodes.forEach(n => {if(n.nodeType===1) attach(n.parentElement || n);}))).observe(document.documentElement,{childList:true,subtree:true});
})();
